
// This is the original file that should be used for toast hooks
import { toast as sonnerToast } from "sonner";
import {
  ToastActionElement,
  ToastProps,
} from "@/components/ui/toast";

export type ToasterToast = {
  id: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: ToastActionElement;
  variant?: "default" | "destructive";
  className?: string;
  duration?: number;
};

const toasts: ToasterToast[] = [];

// Define the interface for the toast function
interface ToastOptions {
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: ToastActionElement;
  variant?: "default" | "destructive";
  className?: string;
  duration?: number;
}

export const toast = (options: ToastOptions) => {
  const id = String(Date.now());
  
  // Map our toast options to sonner toast options
  sonnerToast(options.title as string, {
    description: options.description,
    action: options.action,
    className: options.className,
    duration: options.duration || 5000,
  });
  
  const newToast = {
    id,
    ...options,
  };
  
  toasts.push(newToast);
  
  return newToast;
};

export const useToast = () => {
  return {
    toast,
    toasts,
  };
};
